import { TipoConsolidado } from "./TipoConsolidadoEnum";

export class DteFilter {
	importacionMasivaId: string = "";
	emisorId: string;
	sucursalId: string | string[];
	receptorId: string;
	clienteId?: string;
	tipoDteId?: string | string[];
	fechaDesde: Date;
	fechaHasta: Date;
	estadoSii: number | number[];
	nulos: boolean;
	rutReceptor: string = "";
	razonSocialReceptor: string = "";
	folio: string = "";
	rutEmisor: string;
	codigoSii: string;
	tipoTraslado: string = "";
	tipoDespacho: string = "";
	facturable: string;
	reutilizado: boolean;
	puedenCederse: boolean;
	trackId: number;
	importado: boolean;
	razonSocialProveedor: string;
	estadoAcuse: number | number[];
	ambienteId: number;
	montoTotal: number;
	tipoConsolidado: TipoConsolidado;
	pendientePago?: boolean;
	fileType?: string;
}
